var _filter, _filter2, _filter3, _filter4, _filter5, _radialGradient, _radialGradient2, _linearGradient, _linearGradient2, _linearGradient3, _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 105,
    viewBox: "0 0 98 105",
    width: 98,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 103.621,
    width: 97.8224,
    x: 0.088799,
    y: 0.661133
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_9219_3599",
    stdDeviation: 2
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 32.874,
    width: 34.2213,
    x: 17,
    y: 47.9248
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_3599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_3599",
    mode: "normal",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 28.0371,
    width: 31.5329,
    x: 46.3123,
    y: 59.6484
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_3599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_3599",
    mode: "normal",
    result: "shape"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 29.1172,
    width: 33.0783,
    x: 31.1938,
    y: 54.5928
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_3599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_3599",
    mode: "normal",
    result: "shape"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 61.4629,
    width: 59.8881,
    x: 17.9905,
    y: 25.8164
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_9219_3599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9219_3599",
    mode: "normal",
    result: "shape"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(4.11411522 36.15850057 -34.85580573 3.96589456 50.8004 51.6551)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ffc85c",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#ffc75b",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 35.4864 -49.8277 0 48.9999 52.6611)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc85c",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc759",
    stopOpacity: 0
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc536"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 63.7846,
    x2: 69.0355,
    xlinkHref: "#h",
    y1: 35.6505,
    y2: 53.525
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 47.9034,
    x2: 44.7759,
    xlinkHref: "#h",
    y1: 30.8824,
    y2: 59.9004
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.0617 13.0141 4.6268-.3491 4.6286.2658 4.5573.8766 4.4143 1.4734 4.2015 2.047 3.9226 2.5884 3.5817 3.0889 3.1843 3.5408 2.7369 3.9368 2.2461 4.2706 1.72 4.5372 1.1668 4.7322.5951 4.8526.014 4.8964-.5672 4.863-1.1395 4.753-1.6939 4.5679-2.2215 4.3108-2.7141 3.9858-3.1639 3.5979-3.5638 3.1532-3.9075 2.6589-4.1895 2.1225-4.4056 1.5528-4.552.9585-4.6269.349-4.6285-.2658-4.5574-.8765-4.4142-1.4734-4.2015-2.047-3.9226-2.5884-3.5817-3.0889-3.1844-3.5408-2.7368-3.9368-2.2461-4.2706-1.72-4.5372-1.1668-4.7322-.5951-4.8526-.014-4.8964.5672-4.863 1.1395-4.753 1.6939-4.5679 2.2215-4.3108 2.7141-3.9858 3.1639-3.5979 3.5637-3.1533 3.9075-2.6588 4.1896-2.1225 4.4055-1.5528z",
    fill: "url(#f)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49 4.66113.9917 22.88587c.0982 2.265 3.294 2.6448 3.9203.4659l6.279-21.84376-4.4038 22.57676c-.433 2.2199 2.5732 3.3398 3.6981 1.3776l11.1936-19.5251-9.6129 20.8811c-.9417 2.0456 1.6912 3.8456 3.2555 2.2256l15.4831-16.0345-14.3054 17.8323c-1.4015 1.7471.6889 4.1252 2.6013 2.9591l18.8943-11.5206-18.1359 13.5689c-1.7841 1.3347-.378 4.147 1.7603 3.5207l21.1783-6.2027-20.7908 8.3563c-2.0601.8279-1.4385 3.8948.7814 3.8554l22.1231-.3928-22.0493 2.5743c-2.2036.2572-2.412 3.3762-.2623 3.9245l21.6033 5.5094-21.8286-3.336c-2.198-.3359-3.2212 2.6279-1.284 3.7195l19.6269 11.0596-20.1918-8.9449c-2.0423-.9047-3.806 1.7109-2.2017 3.2651l16.3494 15.8388-17.3144-13.8938c-1.7518-1.4056-4.1332.6988-2.9538 2.6102l12.0454 19.52-13.4322-17.9182c-1.354-1.8062-4.1959-.3362-3.5041 1.8125l7.0516 21.9022-8.7988-20.8382c-.8811-2.0867-4.0056-1.3319-3.8369.9269l1.7101 22.9039-3.666-22.5301c-.3642-2.2384-3.5838-2.2384-3.948 0l-3.666 22.5301 1.7101-22.9039c.1687-2.2588-2.9558-3.0136-3.8369-.9269l-8.7988 20.8382 7.0516-21.9022c.6918-2.1487-2.1501-3.6187-3.5041-1.8125l-13.4322 17.9182 12.0454-19.52c1.1794-1.9114-1.202-4.0158-2.9538-2.6102l-17.3144 13.8938 16.3494-15.8388c1.6043-1.5542-.1594-4.1698-2.2017-3.2651l-20.19182 8.9449 19.62692-11.0596c1.9372-1.0916.914-4.0554-1.284-3.7195l-21.82863 3.336 21.60343-5.5094c2.1497-.5483 1.9412-3.6673-.2624-3.9245l-22.0493-2.5743 22.1231.3928c2.2199.0394 2.8415-3.0275.7814-3.8554l-20.79084-8.3563 21.17834 6.2027c2.1383.6263 3.5443-2.186 1.7603-3.5207l-18.1359-13.5689 18.8943 11.5206c1.9124 1.1661 4.0028-1.212 2.6013-2.9591l-14.3054-17.8323 15.4831 16.0345c1.5643 1.62 4.1972-.18 3.2555-2.2256l-9.6129-20.8811 11.1936 19.5251c1.1249 1.9622 4.1311.8423 3.6981-1.3776l-4.4038-22.57676 6.279 21.84376c.6263 2.1789 3.8221 1.7991 3.9203-.4659z",
    fill: "url(#g)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.3066 66.5493c1.2422 2.6818 6.2131 2.6131 11.1027-.1534 4.8896-2.7666 7.8463-7.1834 6.6041-9.8652-.1288-.2781-.9581-2.0605-1.0894-2.3207-.5619-1.1135-3.0694-3.5118-10.7682.8442-7.8108 4.4194-7.2425 8.392-6.9163 9.1617.1156.2729.9398 2.0585 1.0671 2.3334z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.2014 64.1637c-1.2422-2.6818 1.7145-7.0986 6.6041-9.8651 4.8896-2.7666 9.8605-2.8353 11.1027-.1535s-1.7146 7.0986-6.6042 9.8652c-4.8896 2.7665-9.8604 2.8352-11.1026.1534z",
    fill: "#ffc22a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.392 53.5263c.0027-.1-.1438-.133-.3272-.0699-1.0918.3762-2.1716.8536-3.1883 1.4101-1.1196.6129-2.1406 1.3099-3.0048 2.051-.8643.7412-1.5547 1.512-2.032 2.2685-.4334.687-.6833 1.3499-.7388 1.9577-.0093.1021.1378.1347.3212.0751s.3336-.1888.3434-.291c.0539-.5602.2852-1.1704.684-1.8026.4427-.7017 1.0832-1.4168 1.8849-2.1042.8016-.6875 1.7487-1.334 2.7873-1.9025.9355-.5122 1.9288-.9521 2.9334-1.2997.1833-.0635.3342-.1925.3369-.2925z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.8503 64.2012c.0504.0828.2386.0792.4181-.0112 1.984-.9992 3.7039-2.262 4.8901-3.5904.1073-.1201.0608-.2205-.0977-.2239s-.3688.0915-.4766.2116c-1.0951 1.2211-2.6759 2.3818-4.4985 3.3028-.1793.0907-.2858.2284-.2354.3111z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.273 61.247c-3.1519 2.7566-7.5694 4.0759-9.8668 2.9468-2.2975-1.1291-1.6048-4.2791 1.547-7.0356 3.1518-2.7566 7.5693-4.0759 9.8668-2.9468 2.2974 1.1291 1.6048 4.2791-1.547 7.0356z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.9532 57.1582c3.1518-2.7566 7.5693-4.0759 9.8668-2.9468-3.595 1.229-10.6128 7.0627-11.4138 9.9824-2.2975-1.1291-1.6048-4.2791 1.547-7.0356z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.073 61.6511c.3718-1.1836 1.2936-2.5072 2.7174-3.7523 3.1508-2.7557 7.57-4.0755 9.8667-2.9468 1.0378.51 1.4662 1.4304 1.3332 2.5427.4494-1.4368.0908-2.6635-1.1703-3.2833-2.2967-1.1287-6.716.1911-9.8668 2.9468-1.7271 1.5105-2.7165 3.1414-2.8802 4.4929z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.8532 56.493c.1039-.2359-.4298-.7989-.7031-.6205l-2.9326 2.5713c-.2302.1502-.4652.1164-.4483-.0646l.2242-2.3988c.0272-.2911-.5687-.7773-.7093-.4577l-2.8914 6.5668c-.1039.2359.2051.9455.4784.7671l3.2094-2.0954c.2302-.1502.4653-.1164.4483.0646l-.2763 1.7763c-.0272.2911.5686.7772.7093.4577z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.5765 56.0174c.1039-.2359-.153-.3231-.4263-.1446l-3.2094 2.0953c-.2302.1503-.4652.1165-.4483-.0645l.2241-2.3989c.0272-.291-.5164-.1547-.6571.1649l-2.8914 6.5668c-.1038.2359.153.323.4263.1446l3.2094-2.0954c.2302-.1503.4652-.1164.4483.0645l-.2241 2.3989c-.0272.2911.5164.1547.6571-.1649z",
    fill: "#ffdd28"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.0239 69.0108c-.4739 3.4944 3.3711 6.9712 8.5882 7.7655s9.8306-1.3946 10.3045-4.889c.0492-.3624.1926-1.443.2303-1.7898.1614-1.4838-.4848-5.6044-8.6993-6.8551-8.3339-1.2689-10.0104 3.0009-10.1697 3.9822-.0564.3479-.2055 1.428-.254 1.7862z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.319 66.8353c.4739-3.4945 5.0874-5.6833 10.3045-4.889s9.0622 4.271 8.5883 7.7655c-.4739 3.4944-5.0874 5.6833-10.3045 4.889s-9.0622-4.271-8.5883-7.7655z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.8833 73.3159c-3.8803.4348-7.9663-1.4309-9.1263-4.1671s1.0452-5.3067 4.9255-5.7415c3.8803-.4347 7.9663 1.4309 9.1264 4.1671 1.16 2.7362-1.0453 5.3068-4.9256 5.7415z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.6825 63.4073c3.8803-.4347 7.9663 1.4309 9.1264 4.1671-2.5026-.381-9.4955-1.4457-14.0519 1.5744-1.16-2.7362 1.0452-5.3067 4.9255-5.7415z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.0872 65.7249c.9141-.8863 2.3241-1.5168 4.0768-1.7132 3.8791-.4346 7.9667 1.4318 9.1264 4.1671.524 1.236.3629 2.4367-.3303 3.4239 1.1082-1.0774 1.4855-2.5263.8488-4.0283-1.1597-2.7353-5.2473-4.6017-9.1264-4.1671-2.1263.2382-3.7514 1.1195-4.5953 2.3176z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.4493 62.948c.0512-.1014-.0502-.2238-.2285-.2694-1.0619-.2712-2.1638-.4308-3.2539-.4708-1.2005-.0441-2.3631.0578-3.4214.2998-1.0583.2421-1.9917.6195-2.7467 1.1108-.6856.4461-1.2121.9781-1.5553 1.5706-.0576.0995.0446.2218.2212.2711.1765.0492.3606.0068.4188-.0926.3185-.5444.8041-1.0334 1.435-1.4439.7004-.4557 1.5662-.8058 2.5479-1.0303s2.0601-.319 3.1737-.2782c1.0031.0368 2.0171.1829 2.9948.4308.1785.0453.3631.0034.4144-.0979z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.5676 73.8199c-.0002.1156.1528.2255.3413.2406 2.0847.1676 4.0867-.0955 5.6921-.7481.1453-.059.1572-.1905.0315-.2896-.1256-.0991-.3412-.1282-.4867-.0695-1.4797.5971-3.3197.8389-5.2363.6882-.1885-.0148-.3417.0628-.3419.1784z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.4326 68.77c.2294-.1173.1601-.9529-.167-1.0028l-3.9208-.0025c-.2755-.0419-.4399-.2365-.3134-.3711l1.6758-1.7841c.2034-.2164.037-1.0341-.2737-.8753l-6.9226 3.182c-.2294.1173.1087.9939.4359 1.0437l3.8418.585c.2755.0419.4398.2365.3134.3711l-1.8657 1.1607c-.2034.2165.5006 1.116.8113.9572z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.5118 68.1877c.2294-.1172.0811-.3705-.246-.4203l-3.8418-.585c-.2755-.0419-.4399-.2365-.3134-.3711l1.6758-1.7841c.2034-.2164-.3108-.4926-.6215-.3338l-6.385 3.2639c-.2293.1172-.0811.3705.2461.4203l3.8418.585c.2755.0419.4398.2365.3134.3711l-1.6759 1.7841c-.2033.2164.3108.4926.6215.3338z",
    fill: "#ffdd28"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.3135 67.5733c.5199 3.6391 5.4342 5.8687 10.9764 4.9798 5.5422-.8888 9.6136-4.5594 9.0937-8.1985-.0539-.3774-.2179-1.5018-.279-1.8599-.2612-1.5323-2.1018-5.4352-10.8282-4.0357-8.8532 1.4198-9.3359 6.22-9.2166 7.2504.0423.3653.2004 1.4909.2537 1.8639z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.9899 65.3072c-.5198-3.6391 3.5516-7.3097 9.0938-8.1985 5.5422-.8889 10.4565 1.3407 10.9763 4.9798.5199 3.6391-3.5515 7.3098-9.0937 8.1986s-10.4565-1.3407-10.9764-4.9799z",
    fill: "#ffc32d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.6282 68.0377c-3.8278 1.6842-8.5253 1.1396-10.492-1.2164-1.9666-2.356-.4579-5.6314 3.37-7.3156 3.8279-1.6843 8.5253-1.1397 10.492 1.2164 1.9667 2.356.4579 5.6313-3.37 7.3156z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.5062 59.5057c3.8279-1.6843 8.5253-1.1397 10.492 1.2164-2.6584.4263-10.0871 1.6177-13.862 6.0992-1.9666-2.356-.4579-5.6314 3.37-7.3156z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.4902 63.2988c.6769-1.1788 1.9322-2.2623 3.6613-3.0231 3.8266-1.6837 8.5259-1.1389 10.492 1.2164.8884 1.0643 1.0688 2.3142.646 3.5225.8196-1.4321.7883-2.9993-.2913-4.2925-1.966-2.3553-6.6653-2.9001-10.492-1.2164-2.0975.9229-3.5 2.3259-4.016 3.7931z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.2301 57.5107c.0231-.1177-.1153-.2071-.31-.1951-1.1595.0717-2.3278.2675-3.4496.5789-1.2355.3429-2.3905.8192-3.3991 1.4018-1.0086.5825-1.8511 1.2599-2.4792 1.9933-.5704.6661-.954 1.3665-1.1336 2.0683-.0302.1178.109.2069.303.1991s.3693-.1094.4-.2273c.1683-.6458.5226-1.2901 1.0475-1.9031.5827-.6803 1.3642-1.3086 2.2997-1.849.9356-.5404 2.007-.9822 3.1531-1.3003 1.0324-.2865 2.1071-.4676 3.1743-.5353.1947-.0124.3707-.1137.3939-.2313z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.414 69.2862c.033.1154.2202.1757.4167.1301 2.1715-.5047 4.1354-1.4124 5.5835-2.5808.131-.1057.1054-.2407-.051-.2991s-.3844-.018-.5158.0875c-1.3359 1.0726-3.1408 1.9068-5.1363 2.3741-.1964.046-.3301.1728-.2971.2882z",
    fill: "#ffe77e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.8617 63.2378c.2-.191-.1103-1.0024-.4579-.9467l-3.9945 1.2611c-.2927.0469-.5159-.0943-.4258-.2693l1.1952-2.32c.1451-.2815-.259-1.0437-.5299-.7851l-5.853 5.3598c-.2001.1909.1103 1.0024.4578.9466l4.0812-.6545c.2927-.0469.5159.0943.4258.2693l-1.2819 1.7135c-.145.2815.5446.9978.8155.7393z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.775 62.6308c.2-.1909-.0237-.3959-.3712-.3401l-4.0812.6545c-.2927.0469-.516-.0942-.4258-.2693l1.1952-2.32c.1451-.2815-.4579-.3913-.7288-.1327l-5.5675 5.314c-.2.1909.0236.3958.3712.3401l4.0812-.6546c.2927-.0469.5159.0943.4257.2693l-1.1952 2.32c-.145.2816.458.3914.7289.1328z",
    fill: "#ffdd28"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.7664 47.3869c1.185 5.0219 5.6388 8.0671 9.9477 6.8016 4.309-1.2656 6.0872-2.193 4.031-10.9071-2.0115-8.5246-4.0133-8.5444-8.3223-7.2789-4.3089 1.2656-6.8414 6.3625-5.6564 11.3844z",
    fill: "#f19018"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m68.0685 53.8091c4.3016-1.2636 6.8296-6.353 5.6467-11.3674-1.183-5.0143-5.6291-8.0549-9.9306-6.7912-4.3015 1.2636-6.8296 6.3529-5.6466 11.3673s5.629 8.0549 9.9305 6.7913z",
    fill: "url(#i)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m60.586 43.7948c-.3387 3.6902 1.8246 7.0843 4.832 7.5809 3.0074.4965 5.72-2.0925 6.0587-5.7827.3387-3.6903-1.8246-7.0844-4.832-7.581-3.0074-.4965-5.7199 2.0925-6.0587 5.7828z",
    fill: "#f39e09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m66.2298 38.6177c-3.018-.4984-4.3887 1.3712-4.9469 2.5129 1.8498.6044 6.8121 4.1502 8.5903 8.1717 2.8407-5.0792-.6254-10.1862-3.6434-10.6846z",
    fill: "#ffaa16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m69.1203 50.375c.93-1.0352 1.5656-2.4761 1.7186-4.1431.3387-3.689-1.8256-7.0845-4.832-7.5809-1.3584-.2243-2.6552.1792-3.7022 1.0309 1.1306-1.2556 2.6892-1.9122 4.34-1.6396 3.0064.4964 5.1706 3.8919 4.832 7.5809-.1856 2.0222-1.0859 3.7157-2.3564 4.7518z",
    fill: "#e88102",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m69.1727 44.9642c.2282-.1556.194-.5539-.0569-.6612l-2.9461-1.259c-.2113-.0903-.2789-.4013-.129-.5931l1.9872-2.5423c.2411-.3085-.7693-1.0694-1.0785-.8587l-5.6705 4.6218c-.2283.1556-.1908.9145.06 1.0217l2.9429.8985c.2113.0903.279.4013.129.5931l-1.7956 2.8194c-.2412.3084.8295.8707 1.1387.66z",
    fill: "#e88711"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m69.6756 44.6911c.2162-.1785.1505-.5733-.1091-.6553l-3.0481-.9629c-.2186-.0691-.3109-.3731-.1759-.58l1.7883-2.7417c.217-.3327-.1464-.7683-.4393-.5266l-6.0188 4.9675c-.2163.1784-.1505.5733.109.6553l3.0482.9629c.2186.069.3109.3731.1759.58l-1.7884 2.7417c-.217.3327.1465.7683.4394.5266z",
    fill: "#ffd83b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m62.3648 37.2663c-.0677-.1525-.0148-.3363.1208-.4042.8074-.4042 1.6759-.6405 2.5646-.6971.9787-.0622 1.9628.0948 2.8961.4622s1.7976.938 2.5434 1.6791c.6772.6729 1.2448 1.4746 1.6764 2.3665.0725.1498.019.3333-.1143.4068-.1332.0734-.2956.009-.3685-.1406-.3992-.8195-.9223-1.5563-1.5455-2.1756-.6918-.6874-1.4935-1.2167-2.3592-1.5575-.8658-.3408-1.7786-.4864-2.6865-.4287-.8178.0521-1.6172.2683-2.3611.6378-.1358.0674-.2985.0039-.3662-.1487z",
    fill: "#ffe77e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m67.3518 52.9156c.0278.1665-.0685.3247-.216.3465-1.6309.2413-3.2986-.1377-4.7415-1.0776-.1305-.0851-.1715-.2745-.0945-.4172.0771-.1427.2429-.1847.3736-.1001 1.3288.8601 2.8615 1.2084 4.3617.9914.1476-.0214.2889.0904.3167.257z",
    fill: "#ffe77e"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.8303 47.0149c-.61 8.0496-6.825 13.9587-13.8816 13.1983-7.0565-.7605-10.0691-1.6974-9.0107-15.6653 1.0355-13.6643 4.1631-14.2456 11.2197-13.4852 7.0566.7605 12.2826 7.9025 11.6726 15.9522z",
    fill: "#f19018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.6971 59.9996c-7.0479-.7596-12.2675-7.8934-11.6582-15.9339.6092-8.0405 6.8166-13.9429 13.8645-13.1833s12.2675 7.8935 11.6582 15.934c-.6092 8.0405-6.8166 13.9428-13.8645 13.1832z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.0575 42.4548c1.4137 5.5192-1.216 11.3125-5.8737 12.9398-4.6576 1.6273-9.5794-1.5277-10.9931-7.0468-1.4137-5.5192 1.216-11.3125 5.8737-12.9398s9.5795 1.5277 10.9931 7.0468z",
    fill: "#f39e09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.8492 36.2157c4.6648-1.6302 7.2798.8141 8.4348 2.3874-2.7883 1.4534-9.8126 8.2765-11.6782 14.9013-5.7049-6.8961-1.4215-15.6585 3.2434-17.2887z",
    fill: "#ffaa16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.0602 54.9245c-1.7225-1.3064-3.0738-3.3155-3.7123-5.8086-1.4133-5.5173 1.2175-11.313 5.8737-12.9397 2.1039-.7351 4.2589-.4967 6.1236.4964-2.0934-1.5836-4.7241-2.1315-7.2808-1.2382-4.6561 1.6268-7.2869 7.4224-5.8737 12.9397.7746 3.0243 2.6061 5.3413 4.8695 6.5504z",
    fill: "#e88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.6261 44.3896c.3057-.3407.1156-.9221-.3155-.9648l-5.0621-.502c-.3631-.0361-.5757-.4706-.4057-.8288l2.2543-4.7483c.2736-.5762-1.5752-1.242-1.9892-.7805l-7.3332 9.6007c-.3056.3407-.1155.9221.3155.9649l5.0621.502c.3631.036.5758.4705.4057.8288l-3.4567 4.958c-.2736.5762 1.6019.9156 2.0159.4541z",
    fill: "#e88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.3602 44.2684c.3057-.3407.1156-.9221-.3155-.9648l-5.062-.502c-.363-.036-.5757-.4706-.4056-.8288l2.2543-4.7483c.2735-.5761-.3995-1.1253-.8136-.6638l-8.5086 9.484c-.3057.3407-.1156.9221.3154.9648l5.062.502c.3631.036.5758.4705.4057.8288l-2.2543 4.7482c-.2735.5762.3995 1.1253.8135.6638z",
    fill: "#ffd83b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe77e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.486 33.0258c.0685-.2535-.0605-.5215-.2905-.5884-1.3701-.3982-2.7944-.5213-4.2057-.3621-1.5542.1753-3.0623.6895-4.4381 1.5133-1.3759.8238-2.5925 1.9409-3.5805 3.2877-.8971 1.223-1.5898 2.6135-2.0463 4.1053-.0766.2506.0532.518.281.5941s.4671-.068.5444-.3183c.4235-1.3714 1.0624-2.6498 1.888-3.7752.9165-1.2493 2.045-2.2856 3.3213-3.0497 1.2762-.7641 2.6751-1.2411 4.1168-1.4037 1.2988-.1465 2.6093-.0353 3.8709.3271.2303.0662.4703-.0766.5387-.3301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.6624 58.3628c-.0021.2642.1889.4811.4264.4739 2.6266-.0801 5.1561-1.1257 7.192-2.973.1841-.1671.2014-.4701.0446-.6686s-.4282-.2172-.6128-.0507c-1.8763 1.6926-4.2011 2.6537-6.6159 2.7349-.2376.008-.4321.2193-.4343.4835z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.41 28.3789.3509 4.327 3.6019-2.4234-3.1642 2.9722 4.1404 1.3051-4.2966-.6207 1.5612 4.0508-2.1936-3.7462-2.1937 3.7462 1.5612-4.0508-4.2966.6207 4.1404-1.3051-3.1641-2.9722 3.6018 2.4234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.2175 59.2871.2382 2.9362 2.4441-1.6445-2.1472 2.0169 2.8096.8856-2.9155-.4212 1.0593 2.7488-1.4885-2.5421-1.4886 2.5421 1.0594-2.7488-2.9155.4212 2.8095-.8856-2.1471-2.0169 2.4441 1.6445z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins02);
export default __webpack_public_path__ + "static/media/coins-02.6bf6c2602875147c24ec2879dc038bb7.svg";
export { ForwardRef as ReactComponent };